import { makeObservable } from 'mobx';
import BaseEmployeeStore from '../../shared/stores/baseEmployeeStore';
import { ApplicationSdk } from '../../core/sdk';

class EmployeeMenuStore extends BaseEmployeeStore {
    constructor(sdk: ApplicationSdk) {
        super(sdk);

        makeObservable(this, {});
    }

    public async onInit(): Promise<void> {
        // tbc
    }

    get isBackButtonVisible(): boolean {
        return this.sdk.locationAction !== 'menu';
    }

    get isFooterButtonVisible(): boolean {
        return false;
    }
}

export default EmployeeMenuStore;
